import { authApiService } from '@/api/authApiService';
import { RequestOptions } from '@/types/sharedTypes';

export const addOrgAdminRoleApi = async (organizationId: string, payload, options?: RequestOptions) => {
  const uri = `/opco/organizations/${organizationId}/user:add/`;

  return authApiService.POST(uri, payload, null, options);
};
